
/**
 * RelivConferenceTicket
 * @param uid
 */
var RelivConferenceTicket = function (uid) {
    /**
     * self
     */
    var self = this;

    /**
     * conferenceId *REQUIRED
     * @type {int}
     */
    self.conferenceId = null;
    /**
     * firstName *REQUIRED
     * @type {string}
     */
    self.firstName = null;
    /**
     * displayName *REQUIRED
     * @type {string}
     */
    self.displayName = null;
    /**
     * displayRcn *REQUIRED
     * @type {string}
     */
    self.displayRcn = null;
    /**
     * featureData
     * @type {{}}
     */
    self.featureData = [];
    /**
     * hearingImpaired *REQUIRED
     * @type {boolean}
     */
    self.hearingImpaired = 0;
    /**
     * lastName *REQUIRED
     * @type {string}
     */
    self.lastName = null;
    /**
     * orderNumber
     * @type {int}
     */
    self.orderNumber = null;
    /**
     * ownerRank
     * @type {string}
     */
    self.ownerRank = null;
    /**
     * ownerRcn
     * @type {string}
     */
    self.ownerRcn = null;
    /**
     * ownerStatus
     * @type {string}
     */
    self.ownerStatus = null;
    /**
     * signLanguage *REQUIRED
     * @type {boolean}
     */
    self.signLanguage = 0;
    /**
     * skuNumber *REQUIRED
     * @type {string}
     */
    self.skuNumber = null;
    /**
     * translationLangCode *REQUIRED
     * @type {string}
     */
    self.translationLangCode = 'eng';
    /**
     * type
     * @type {string}
     */
    self.type = 'conferenceTicket';
    /**
     * uid *REQUIRED
     * @type {string}
     */
    self.uid = uid;
};

export default RelivConferenceTicket;
